(function () {
  'use strict';

  function openHashTarget() {
    if (!window.location.hash) return;
    var id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); }
    catch (error) { return; }
    var target = document.getElementById(id);
    if (!target || !target.closest('.yl-security-info')) return;
    var disclosure = target.closest('details.yl-security-info__details');
    if (disclosure) disclosure.open = true;
    window.requestAnimationFrame(function () { target.scrollIntoView({ block: 'start' }); });
  }

  function openForPrint() {
    document.querySelectorAll('.yl-security-info details.yl-security-info__details').forEach(function (detail) {
      detail.dataset.ylPrintWasOpen = detail.open ? '1' : '0';
      detail.open = true;
    });
  }

  function restoreAfterPrint() {
    document.querySelectorAll('.yl-security-info details.yl-security-info__details').forEach(function (detail) {
      if (detail.dataset.ylPrintWasOpen === '0') detail.open = false;
      delete detail.dataset.ylPrintWasOpen;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openHashTarget);
  else openHashTarget();
  window.addEventListener('hashchange', openHashTarget);
  window.addEventListener('beforeprint', openForPrint);
  window.addEventListener('afterprint', restoreAfterPrint);
}());
